"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdatePartialLineItem = void 0;
const client_1 = require("@apollo/client");
const MapmakerApi_1 = require("../../client/MapmakerApi");
const storefrontCheckoutHooks_1 = require("../../client/storefront/storefrontCheckoutHooks");
const attributeUtils_1 = require("./attributeUtils");
(0, client_1.gql) `
  mutation storefrontReplaceCheckoutLineItems(
    $checkoutId: ID!
    $lineItems: [StorefrontCheckoutLineItemInput!]!
  ) {
    storefrontCheckoutLineItemsReplace(
      checkoutId: $checkoutId
      lineItems: $lineItems
    ) {
      checkout {
        ...StorefrontCheckoutHeavy
      }
    }
  }
`;
/**
 * This method exists because updating a line item using checkoutLineItemsUpdate will always
 * update every unit of the line item (when quantity is greater than 1). So if you only want to
 * update only some of those units in a single call then updating all the items is required.
 */
function useUpdatePartialLineItem() {
    const { checkout } = (0, storefrontCheckoutHooks_1.useStorefrontCheckoutHeavy)();
    const [replaceCheckoutLineItemsMutation, status,] = (0, MapmakerApi_1.useStorefrontReplaceCheckoutLineItemsMutation)();
    const updateCheckoutLineItem = (lineItemId, customAttributes, quantityToUpdate) => __awaiter(this, void 0, void 0, function* () {
        if (!checkout) {
            throw new Error(`Error updating your cart. Please contact us if the problem persists.`);
        }
        // Combine line items by ID with quantities combined
        const lineItemsGroupedById = groupLineItemsById(checkout.lineItems);
        const existingLineItem = lineItemsGroupedById.find(lineItem => lineItem.id === lineItemId);
        if (!existingLineItem) {
            throw new Error(`Error updating your cart. Please contact us if the problem persists.`);
        }
        // Only update up to the existing quantity.
        quantityToUpdate = Math.min(quantityToUpdate, existingLineItem.quantity);
        const newLineItems = Object.values(lineItemsGroupedById).flatMap(lineItem => {
            var _a;
            const variantId = (_a = lineItem.variant) === null || _a === void 0 ? void 0 : _a.id;
            const existingCustomAttributes = lineItem.customAttributes.map(attributeUtils_1.attributeToAttributeInput);
            if (lineItem.id === existingLineItem.id) {
                const newLineItem = {
                    quantity: quantityToUpdate,
                    variantId,
                    customAttributes,
                };
                if (lineItem.quantity - quantityToUpdate === 0) {
                    return newLineItem;
                }
                else {
                    return [
                        // Old instance - only if there are leftovers
                        {
                            quantity: lineItem.quantity - quantityToUpdate,
                            variantId,
                            customAttributes: existingCustomAttributes,
                        },
                        // New line item
                        newLineItem,
                    ];
                }
            }
            else {
                // Don't touch the other items
                return {
                    quantity: lineItem.quantity,
                    variantId,
                    customAttributes: existingCustomAttributes,
                };
            }
        });
        return yield replaceCheckoutLineItemsMutation({
            variables: {
                checkoutId: checkout.id,
                lineItems: newLineItems,
            },
        });
    });
    return [updateCheckoutLineItem, status];
}
exports.useUpdatePartialLineItem = useUpdatePartialLineItem;
/*
export function getLineItemTrueQuantity(
  checkout: CheckoutLightFragment | undefined,
  lineItem: Pick<CheckoutLineItem, "id" | "quantity">
): number {
  if (!checkout) {
    return lineItem.quantity;
  } else {
    const realId = getTrueId(lineItem.id);
    return checkout.lineItems.edges.reduce<number>((total, { node }) => {
      const matchesId = Math.abs(getTrueId(node.id) - realId) <= 1;
      return total + (matchesId ? node.quantity : 0);
    }, 0);
  }
}

function getTrueId(id: string): number {
  return parseInt(
    atob(id)
      .split("//")[1]
      .split("/")[2]
      .split("?")[0]
  );
}
*/
function groupLineItemsById(lineItems) {
    const groups = lineItems.edges.reduce((groups, { node: lineItem }) => {
        if (groups[lineItem.id]) {
            const existingLineItem = groups[lineItem.id];
            return Object.assign({ [lineItem.id]: Object.assign(Object.assign({}, existingLineItem), { quantity: existingLineItem.quantity + lineItem.quantity }) }, groups);
        }
        else {
            return Object.assign({ [lineItem.id]: lineItem }, groups);
        }
    }, {});
    return Object.values(groups);
}
//# sourceMappingURL=data:application/json;base64,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